import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

/**
 * Modules métier activés selon l'abonnement de la company.
 * Source de vérité = backend (GET /api/modules) ; le masquage UI vient en plus
 * de la garde serveur require_module (jamais l'un sans l'autre).
 */
export function useModules() {
  const { data, isLoading } = useQuery({
    queryKey: ["modules"],
    queryFn: async () => (await api.get("/modules")).data,
    staleTime: 5 * 60 * 1000,
  });
  return {
    modules: data?.modules || {},
    plan: data?.plan,
    // Univers proposés à CET utilisateur (calcul serveur : rôle + abonnement).
    // Défaut prudent avant chargement / anciens backends : chantier seul.
    universes: data?.universes || { chantier: true, maintenance: false },
    isLoading,
  };
}

export function useModule(key) {
  const { modules, isLoading } = useModules();
  return { enabled: !!modules[key], isLoading };
}
